// extracted by mini-css-extract-plugin
module.exports = {"root":"Content_root__1iPq2","isGrabbing":"Content_isGrabbing__1o5r-"};